import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SaveProgramPayload } from "../types/programType";

export const getProgramList = createAsyncThunk("/program/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/programs?${query.toString()}`)).data;
  return response;
});

export const getProgramDetail = createAsyncThunk("/program/detail", async (slug: string) => {
  const response = (await api.get(`/programs/${slug}`)).data;
  return response;
});

export const saveProgram = createAsyncThunk("/program/save", async (payload: SaveProgramPayload) => {
  const response = (await api.post("/programs/action", payload)).data;
  return response;
});

export const deleteProgram = createAsyncThunk("/program/delete", async (id: number) => {
  const response = (await api.get(`/programs/delete/${id}`)).data;
  return response;
});
